import { SubdimensionCounts } from '@/features/reports';
import { apiSlugToDimensionName } from '@components/Dashboard/dashboardSlice/responseMappers/dimensionStats';
import { Chip, ChipProps, Stack } from '@mui/material';

export const ALL_OPTION = {
  name: 'All',
  value: 'all',
} as const;

export type DimensionChipsProps = {
  dimensionCounts: SubdimensionCounts;
  allSubdimensionsCount: number;
  activeTab: string;
  onChange: (dimension: string) => void;
};

export const DimensionChips = (props: DimensionChipsProps) => {
  const getChipColor = (dimension: string): ChipProps['color'] => {
    return props.activeTab === dimension ? 'primary' : 'default';
  };

  return (
    <Stack direction="row" gap="0.5rem">
      <Chip
        variant="outlined"
        color={getChipColor(ALL_OPTION.value)}
        label={`${ALL_OPTION.name} (${props.allSubdimensionsCount})`}
        onClick={() => props.onChange(ALL_OPTION.value)}
      />
      {Object.entries(props.dimensionCounts).map(([dimension, count]) => (
        <Chip
          key={dimension}
          variant="outlined"
          color={getChipColor(dimension)}
          label={`${
            apiSlugToDimensionName[
              dimension as keyof typeof apiSlugToDimensionName
            ]
          } (${count})`}
          onClick={() => props.onChange(dimension)}
        />
      ))}
    </Stack>
  );
};
